import { useNavigate } from 'react-router-dom';
import { useSearchAndResolveCustomer } from 'hooks/useSearchAndResolveCustomer';
import { useCallback, useEffect, useMemo } from 'react';
import { SearchCustomerInput } from 'gql/__generated/vp-apollo';

export const useCustomerSearchActions = () => {
    const navigate = useNavigate();
    const { searchAndResolveCustomer, installationAddress, loading, error } = useSearchAndResolveCustomer();

    const search = useCallback(
        (formData: SearchCustomerInput) => searchAndResolveCustomer(formData),
        [searchAndResolveCustomer]
    );

    const goBackPath = useMemo(() => '/', []);
    const skipPath = useMemo(() => '../pruefe-adresse', []);

    useEffect(() => {
        if (installationAddress) {
            const { street, houseNumber, zip, city } = installationAddress.address;

            navigate('../pruefe-adresse', {
                replace: true,
                state: {
                    address: {
                        street,
                        houseNumber,
                        zip,
                        city,
                    },
                },
            });
        }
    }, [navigate, installationAddress]);

    return {
        search,
        skipPath,
        goBackPath,
        loading,
        error,
    };
};
